@if (isLoadingServices) {
  <div class="loading-indicator">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
} @else {
  <div class="service-info-container" [formGroup]="formRef">
    @for (
      sli of formRef.controls.services['controls'];
      track sli.value.id;
      let i = $index
    ) {
      <div [formGroup]="sli" class="line-item">
        <!-- If more than one service exists, show dropdowns with multiple services -->
        @if (allServices.length > 1) {
          <div class="question primary">Select service by</div>
          <mat-radio-group
            class="default-contact-options"
            formControlName="identifyIssueBy"
            (change)="onServiceByRadioChange(i)"
          >
            <mat-radio-button
              class="service-location-radio"
              value="location"
              checked
            >
              <div class="icon-text">
                <!-- <div class="custom-icon location"></div>
                <div class="custom-icon location_dark"></div> -->
                Location
              </div>
            </mat-radio-button>
            <mat-radio-button class="service-location-radio" value="service">
              <div class="icon-text">
                <!-- <div class="custom-icon circuit"></div>
                <div class="custom-icon circuit_dark"></div> -->
                Service
              </div>
            </mat-radio-button>
          </mat-radio-group>

          <!--- BY LOCATION
          - if there is one location, there is only one service: display both static
          - if there is one location and multiple services: display location static and services as a dropdown
          - if there are many locations: display location dropdown and hide service information
          ---- choosing a location with one service: display service static
          ---- choosing a location with many services: display service dropdown -->
          @if (formRef.value.services[i].identifyIssueBy == 'location') {
            <app-autocomplete-location
              [allLocations]="allLocations"
              [locationIterator]="i"
              (locationSelected)="locationSelected($event)"
            ></app-autocomplete-location>

            @if (
              formRef.value.services[i].locationId &&
              formRef.value.services[i].servicesByLocation.length > 1
            ) {
              <div class="question">Which service?</div>
              <mat-form-field>
                <mat-label>Please select a service</mat-label>
                <mat-select
                  formControlName="serviceId"
                  (valueChange)="onServiceSelected($event, i)"
                >
                  @for (s of allServices; track s.id) {
                    @if (s.locationId == formRef.value.services[i].locationId) {
                      <mat-option [value]="s.id" [disabled]="s.disabled">
                        {{ s.nit }} – {{ s.product }}
                        @if (s.bandwidth) {
                          <span> - {{ s.bandwidth }} </span>
                        }
                        @if (s?.alias) {
                          <span> - {{ s?.alias }} </span>
                        }
                      </mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
            }

            @if (
              formRef.value.services[i].locationId &&
              formRef.value.services[i].servicesByLocation.length === 1
            ) {
              <div class="question">Service:</div>
              {{ formRef.value.services[i].servicesByLocation[0].nit }} -
              {{ formRef.value.services[i].servicesByLocation[0].product }}
            }
          }

          <!-- BY SERVICE -->
          <app-autocomplete
            [allServices]="allServices"
            [ticketType]="ticketType"
            [selectedServiceId]="formRef.value.services[i].serviceId"
            [formRef]="formRef"
            [identifyIssueBy]="formRef.value.services[i].identifyIssueBy"
            [serviceIterator]="i"
            (serviceSelected)="serviceSelected($event)"
          ></app-autocomplete>

          @if (formRef.value.services.length > 1) {
            <button
              class="button-remove-service"
              (click)="removeServicesFormControl(i)"
            >
              remove
            </button>
          }
        }

        <!-- If only one service exists, show service details -->
        @if (allServices.length === 1) {
          <p class="one-service">
            {{ allServices[0].nit }} - {{ allServices[0].product }}
          </p>
          <p>{{ formRef.value.services[0].locationAddress }}</p>
        }

        <!-- If no service exists -->
        @if (allServices.length === 0) {
          <div class="question">There are no active services available.</div>
        }
      </div>
    }

    @if (allServices.length > 1) {
      @if (formRef.value.services.length != allServices.length) {
        <div class="alt-contact-options disconnect-another-service">
          <button mat-fab class="cta" (click)="addServicesFormControl()">
            <div class="custom-icon add_button"></div>
          </button>
          <div>
            <button class="cta-label" (click)="addServicesFormControl()">
              Select Another Service
            </button>
          </div>
        </div>
      }
    }

    @if (selectedServicesTotal == allServices.length) {
      <p class="one-service">There are no more services available.</p>
    }
  </div>
}
